import { useEffect, useState } from "react";
import { Badge, Button, Col, Row, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form } from "reactstrap";
import {   Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
  TooltipComponent,
  UserAvatar, } from "../../../components/Component";
import { labAPI } from "../../../api/doctor";

import MyDataTable from "../../../MyComp/UI/DataTable/MyDataTable";


import moment from "moment";


import { toast } from "react-toastify";



import MyInput from "../../../MyComp/UI/form/MyInput";
import MySelect from "../../../MyComp/UI/form/MySelect";

import { addTestProfile, deleteLapProfile, getLabProfileList, getZipDetailsAPI, updateLab, updateLabProfileAPI, uploadTestCatalog } from "../../../api/master/indes";
import { useForm } from "react-hook-form";







import { useLocation } from "react-router";



import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import Status from "../../../MyComp/UI/form/Status";
import MyButton from "../../../MyComp/UI/form/MyButton";
import ConfirmModal from "../../../MyComp/UI/modals/ConfirmModal";
import { categoryTestDDAPI, subCategoryDDAPI } from "../../../api/dropdown";
import DeleteModal from "../../../MyComp/UI/modals/DeleteModal";
import useLogout from "../../../hooks/useLogout";
import { BASE_URL_IMG } from "../../../assets/constants";

const LaboratoryProfile = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    reset,
    clearErrors,
    getValues,
    // reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      addSub: false,
      data: [],
    },
  });

  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");

  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");

  const [column] = useState([
    // {
    //   name: "Image",
    //   selector: (row) => (
    //     <UserAvatarCell
    //       row={row}
    //       name={row?.TestName}
    //       image={`${BASE_URL_IMG}${row.image || ""}`}
    //     />
    //   ),
    //   sortable: false,
    //   wrap: true,
    // },
    // { name: "Lab ID", selector: (row) => row.labId, sortable: true },
    { name: "Category", selector: (row) => row.Category, sortable: true },
    { name: "Test Name", selector: (row) => row.TestName, sortable: true, wrap: true },
    { name: "MRP", selector: (row) => row.MRP, sortable: true },
    { name: "Discount", selector: (row) => row.disc_perc, sortable: true },
    { name: "Net", selector: (row) => row.Net, sortable: true },
     { name: "Type", selector: (row) => row.Type, sortable: true },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          {" "}
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "90px",
    },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <>
          {" "}
          <Button className="me-1" outline color="warning" size="xs" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>{" "}
          <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" onClick={() => handleDeleteClick(row)} />
          </Button>
        </>
      ),
    },
  ]);

  const labId = localStorage.getItem("userId");
  useEffect(() => {
    getLabProfileListAPI();
  }, []);
  const getLabProfileListAPI = async () => {
    try {
      setValue("isLoading", true);

      const bodyData = {
        labId: labId,
      };

      const res = await getLabProfileList();

      if (res.data.status === "expired") {
        console.log(res.data.data, "res.datata");
        toast.clearWaitingQueue();
        logout();
      } else if (res.data.status === true) {
        setValue("data", res.data.data || []);
      } else {
        setValue("data", []);
      }
    } catch (err) {
      // toast.error(err?.response?.data?.message || "Failed to fetch data");
    } finally {
      setValue("isLoading", false);
    }
  };

  const location = useLocation();
  console.log(location, "location");
  const handleUploadClick = () => {
    setDownloadModalOpen(true);
  };

  const [uploading, setUploading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const discountType = [
    { value: "percentage", label: "percentage" },
    {
      value: "fixed",
      label: "fixed",
    },
  ];
const handleEdit = (row) => {
  setMode("Edit");
  setSelectedRow(row);
  setIsOpen(true);

  /* ---------- CATEGORY ---------- */
  const category = watch("categoryDD")?.find(
    (c) => c.value === row.categoryId
  );

  setValue("category", category || null);

  /* ---------- SUBCATEGORY ---------- */
  if (row.subcategoryId) {
    getSubCategory(row.categoryId);

    setTimeout(() => {
      const sub = watch("subCategoryDD")?.find(
        (s) => s.value === row.subcategoryId
      );
      setValue("subcategory", sub || null);
    }, 200);
  } else {
    setValue("subcategory", null);
  }

  /* ---------- TEST FIELDS ---------- */
  setValue("test", row.TestName);
  setValue("mrp", row.MRP);
  setValue("disc_perc", row.disc_perc);
setValue("discountType", {label :row.discount_type,value:row.discount_type});
  // setValueTest(
  //   "discountType",
  //   discountType.find(
  //     (d) =>
  //       d.value?.toLowerCase() === row.discount_type?.toLowerCase()
  //   ) || null
  // );

  setValue("status", {
    value: row.status ? "Active" : "Inactive",
    label: row.status ? "Active" : "Inactive",
  });
};




  console.log(errors, "errors");

  const resetF = () => {
    setValue("subcategory", null);
    setValue("category", null);
    setValue("discountType", null);
    setValue("test", null);
    setValue("mrp", "");
  setValue("disc_perc", "");
    setValue("status", null);
    setValue("addSub", false);
        clearErrors()
  
  };
 const onFormSubmit = (formData) => {
  const category = getValues("category");
  const subcategory = getValues("subcategory");

  const payload = {
    Testname: formData.test,
    discount_type: formData.discountType?.value,
    Category: category?.label,
    Type: subcategory?.label || null,

    categoryId: category?.value,
    subcategoryId: subcategory?.value || null, 

    MRP: Number(formData.mrp),
    disc_perc: Number(formData.disc_perc),

    ...(mode === "Edit" && { id: selectedRow?.id }),
  };

  setLoading(true);

  const apiCall =
    mode === "Add"
      ? addTestProfile(payload)
      : updateLabProfileAPI(payload);

  apiCall
    .then((res) => {
      setLoading(false);
      if (res?.data?.status) {
        toast.success(res.data.message);
        setIsOpen(false);
        resetF();
      
        getLabProfileListAPI();
      } else {
        toast.error(res.data.message);
      }
    })
    .catch(() => {
      setLoading(false);
      toast.error("Something went wrong");
    });
};


useEffect(() => {
  const categoryId = watch("category")?.value;

  if (categoryId) {
    getSubCategory(categoryId);
  } else {
    setValue("subCategoryDD", []);
    setValue("subcategory", null);
  }
}, [watch("category")]);

  const handleToggleStatus = (row) => {
    console.log(row, "rowtoggle");
    setSelectedRow(row);
    setShowModal(true);
  };
  const confirmStatusChange = () => {
    const updatedStatus = !selectedRow.status;

    setLoading(true);

    updateLab({ labTestId: selectedRow.id, status: updatedStatus })
      .then((res) => {
        setLoading(false);

        if (res.data.status === true) {
          toast.success(res.data.message);

          const updatedData = (watch("data") || []).map((item) =>
            item.id === selectedRow.id ? { ...item, status: updatedStatus } : item,
          );

          setValue("data", updatedData);
          setShowModal(false);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    getCategory();
  }, [mode]);
  const getCategory = () => {
    categoryTestDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    setValue("subcategory", null);
  }, [watch("category")]);


  const getSubCategory = (categoryId) => {
    const body = { categoryId };

    subCategoryDDAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          setValue("subCategoryDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const handleDeleteClick = (row) => {
    // setSelectedRow(row);
    setValue("selectedRow", row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    deleteLapProfile({ id: watch("selectedRow").id })
      .then((res) => {
        // setLoading(false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
          setValue(
            "data",
            watch("data").filter((item) => item.id !== watch("selectedRow")?.id),
          );
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
    const {
    clearErrors: clearErrorsTest,
    register: registerTest,
    handleSubmit: handleSubmitTest,
    control: controlTest,
    setValue: setValueTest,
    watch: watchTest,
    trigger: triggerTest,
    formState: { errors: errorsTest },
    reset: resetTest,
   setError: setErrorTest
  } = useForm({
    defaultValues: {
      isLoading: false,
      addSub: false,
      data: [],
    },
    mode: "onChange",
  });
  // const handleUploadClick = () => {
  //     setDownloadModalOpen(true);
  //   };
      // const labId = localStorage.getItem("userId");

    // New: Handle Upload click to show download modal
    const uploadTestCatalogAPI = async () => {
      try {
        setUploading(true);
        const file = watchTest("file");
        if (!file) {
          toast.errorsTest("Please select an Excel file");
          return;
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("labId", labId);
  
        const res = await uploadTestCatalog(formData);
  
        if (res?.data?.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res?.data?.status === true) {
          toast.success(res.data.message || "Excel uploaded successfully");
          handleCancel();
          setDownloadModalOpen(false);
          setValueTest("data", res.data.data || []);
        } else {
          toast.error(res?.data?.message || "Upload failed");
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Upload failed");
      } finally {
        setUploading(false);
      }
    };
  
    const handleChange = (e) => {
      const selectedFile = e.target.files[0];
  
      if (!selectedFile) {
        setValueTest("file", null);
        setErrorTest("file", { type: "manual", message: "File is required" });
        return;
      }
  
      validateExcel(selectedFile, (isValid) => {
        if (isValid) {
          clearErrorsTest("file");
          setValueTest("file", selectedFile);
        } else {
          setValueTest("file", null);
          setErrorTest("file", { type: "manual", message: "Invalid file type. Please upload a valid Excel file." });
          toast.error("Invalid file type. Please upload a valid Excel file.");
          e.target.value = null;
        }
      });
    };
    useEffect(() => {
      if (!downloadModalOpen) {
        setValueTest("file", null);
        clearErrorsTest("file");
  
        // reset actual file input DOM value
        const input = document.getElementById("fileInput");
        if (input) {
          input.value = "";
        }
      }
    }, [downloadModalOpen]);
    const handleCancel = () => {
      setValueTest("file", null);
      clearErrorsTest("file");
  
      const input = document.getElementById("fileInput");
      if (input) {
        input.value = "";
      }
    };
  
    // const handleCancel = () => {
    //   setValue("file", null);
    //   clearErrors("file");
    // };
    const validateExcel = (file, callback) => {
      const reader = new FileReader();
  
      const fileName = file.name.toLowerCase();
      const isXlsExtension = fileName.endsWith(".xls");
      const isXlsxExtension = fileName.endsWith(".xlsx");
  
      if (!isXlsExtension && !isXlsxExtension) {
        callback(false);
        return;
      }
  
      reader.onloadend = function (event) {
        const arr = new Uint8Array(event.target.result).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16).padStart(2, "0");
        }
        header = header.toUpperCase();
  
        const isXls = header === "D0CF11E0"; // XLS
        const isXlsx = header === "504B0304"; // XLSX
        const isExcel = (isXls && isXlsExtension) || (isXlsx && isXlsxExtension);
  
        callback(isExcel);
      };
  
      reader.onerror = function () {
        callback(false);
      };
  
      reader.readAsArrayBuffer(file.slice(0, 4));
    };
  
  
  
    const handleSampleFileOpen = () => {
      const upload = "upload-test-catalog";
      const fileName = `${BASE_URL_IMG}${upload}`;
      // Replace 'sample_file.txt' with the name of your sample file
      // const fileName = watch("file_name");
      var filePath;
      // Path to your sample file
      // if (selectedType?.value == "facility") {
      filePath = ` ${watch("file_name")}`; // Update the path
      // } else {
      //   filePath = `${base}${sampelFileV2}`; // Update the path
      // }
      const link = document.createElement("a");
      link.href = filePath;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  return (
    <>
      <Head title="Test | Master" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Lab Profile List
              </BlockTitle>
            </BlockHeadContent>

            <BlockHeadContent><div style={{display:"flex",alignItems:"center"}}>
                 <Button color="primary" outline style={{ marginRight: "15px" }} onClick={handleUploadClick}>
                  <Icon name="upload" />
                </Button>
              <div>
                <Button
                  color="primary"
                  outline
                  className="me-n1"
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div></div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="3" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Group"}
                      name={"category"}
                      placeholder={"Select package"}
                      required
                      options={watch("categoryDD")}
                      // multi
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Sub Category"}
                      name={"subcategory"}
                      placeholder={"Select Group"}
                      required
                      options={watch("subCategoryDD")}
                      // multi
                    />
                  </Col>
                  {/* <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Category"
                      name="category"
                      placeholder="Enter Category name"

                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col> */}
                  <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Test Name"
                      name="test"
                      placeholder="Enter Test name"
                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col>
                  <Col md="3">
                    <MySelect
                        register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Discount Type"
                      name="discountType"
                      placeholder="Select discount type"
                      required
                      options={discountType}
                      disabled={mode === "Approval"}
                    />
                  </Col>
                  {/* <Col md="3">
                    <MyInput
                       register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Discount"
                      name="discount"
                      placeholder="Enter Discount"
                      required
                      // min={2}
                      // max={50}
                      disabled={watch("addSub")}
                    />
                  </Col> */}
                  <Col md="3">
                    <MyInput
                       register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="MRP"
                      name="mrp"
                      pattern={/^[0-9]+$/}
                      patternMsg="Only numbers are allowed"
                      placeholder="Enter MRP "
                      required
                      // min={2}
                      // max={50}
                      disabled={watch("addSub")}
                    />
                  </Col>
                  <Col md="3">
                    <MyInput
                       register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Discount"
                      name="disc_perc"
                      placeholder="Enter Discounted Percentage"
                      required
                      // min={2}
                      // max={50}
                      disabled={watch("addSub")}
                    />
                  </Col>
                  {/* <Col md="4">
                    <MyInput
                      register={registerTest}
                      watch={watchTest}
                      setValue={setValueTest}
                      trigger={triggerTest}
                      Test
                      errors={errorsTest}
                      title="Net Price"
                      name="net_price"
                      placeholder="Enter Net Price"
                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col> */}
                  {/* 
                  <Col md="2">
                    <ImageUpload
                      name="disease_img"
                      id="disease_image"
                      watch={watch}
                      label="Upload Test Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="disease_img"
                      image_url="disease_image"
                      setValue={setValue}
                      //   handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col> */}

                  <Col md="3">
                    <Status
                      title={"Status"}
                         register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Col md="2">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={data || []} columns={column} title="Lab Profile List" isLoading={isLoading} />
        </Block>
      </Content>
      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={watch("selectedRow")}
        loading={isLoading}
      />

      {/* Confirm Status Change Modal */}
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={!watch("selectedRow")?.status}
      />
  <Modal isOpen={downloadModalOpen} toggle={() => setDownloadModalOpen(false)} centered>
        <ModalHeader toggle={() => setDownloadModalOpen(false)}>Upload Test Catalog (Excel)</ModalHeader>

        <ModalBody>
          <div className="d-block justify-content-between">
            <div
              style={{
                // maxWidth:'250px',
                border: "2px dashed #cfd4da",
                borderRadius: "10px",
                padding: "5px",
                textAlign: "center",
                background: "#f8f9fa",
              }}
            >
              {watchTest("file") ? (
                <div
                  style={{
                    border: "1px solid #dee2e6",
                    borderRadius: "10px",
                    padding: "20px",
                    background: "#ffffff",
                  }}
                >
                  <Icon name="file-excel" style={{ fontSize: "28px", color: "green" }} />
                  <p
                    style={{
                      marginTop: "10px",
                      wordBreak: "break-word",
                      fontWeight: "600",
                    }}
                  >
                    {watchTest("file")?.name}
                  </p>

                  <div className="d-flex justify-content-center gap-2 mt-3">
                    <Button color="danger" size="sm" className="p-2" outline onClick={handleCancel}>
                      Remove
                    </Button>
                    <Button
                      className="p-2"
                      color="primary"
                      size="sm"
                      disabled={uploading}
                      onClick={uploadTestCatalogAPI}
                    >
                      {/* {uploading ? "Uploading..." : "Upload"} */}
                      {"Upload"}
                    </Button>
                  </div>
                </div>
              ) : (
                /* FILE INPUT */
                <>
                  <label
                    htmlFor="fileInput"
                    style={{
                      cursor: "pointer",
                      display: "block",
                    }}
                  >
                    <Icon name="upload" style={{ fontSize: "30px", color: "#0d6efd" }} />
                    <p style={{ marginTop: "5px", fontWeight: "500" }}>Click to upload test catalog</p>
                    {/* <small style={{ color: "#6c757d" }}>
              Supported formats: .xls, .xlsx
            </small> */}
                  </label>

                  <input
                    type="file"
                    id="fileInput"
                    accept=".xls,.xlsx"
                    style={{ display: "none" }}
                    {...registerTest("file", { requiredTest: "File is required" })}
                    onChange={handleChange}
                  />

                  {errorsTest.file && (
                    <div style={{ color: "red", fontSize: "11px", marginTop: "5px" }}>{errorsTest.file.message}</div>
                  )}
                </>
              )}
            </div>

            {/* SAMPLE DOWNLOAD */}
            <div
              style={{
                border: "2px,solid,lightgray",
                borderRadius: "10px",
                paddingLeft: "50px",
                marginBottom: "10px",
                paddingTop: "15px",
                paddingRight: "25px",
                paddingBottom: "15px",
                marginTop: "10px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                alignItems: "center",
              }}
            >
              <small style={{ color: "crimson" }}>Download sample Excel</small>

              <Button size="sm" color="primary" outline onClick={handleSampleFileOpen}>
                <Icon name="download" /> Sample
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {/* View Image or PDF */}
    </>
  );
};

export default LaboratoryProfile;
